/**
 * @file Component for showing the children of a one to many relation of the selected parent entity.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { DomainService } from '../../domain.service';
import { DialogService } from '../../core/dialog.service';
import { AlertsService } from '../../core/alerts.service';
import { OverlayService } from '../../core/overlay.service';
import { LocalStorageService } from '../../core/local-storage.service';
import { RelationBase } from '../../base/relation/relation.base';
import { EventsService } from '../../core/event.service';
import { GridService } from '../../grids/grid.service';
import { UserService } from '../../user.service';
import { ActionService } from '../../core/action.service';
/**
 * Component for showing the children of a one to many relation of the selected parent entity.
 */
var RelationComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RelationComponent, _super);
    /**
     * Constructs a RelationComponent.
     * @param configurationsService Service to get the configuration of this component.
     * @param domainService Service to load and save entity data.
     * @param dialogService Service for displaying dialogs.
     * @param alertsService Service for publish alerts.
     * @param route The active route.
     */
    function RelationComponent(userService, domainService, dialogService, alertsService, translateService, router, overlayService, localStorageService, route, eventsService, actionService) {
        return _super.call(this, userService, domainService, dialogService, alertsService, translateService, router, overlayService, localStorageService, route, eventsService, actionService) || this;
    }
    /**
     * Method to determine wether or not the component is shown.
     * @returns {boolean} False to hide the component otherwise true.
     * @memberOf RelationComponent
     * */
    RelationComponent.prototype.canShowComponent = function () {
        if (!_super.prototype.canShowComponent.call(this)) {
            return false;
        }
        if (this.entityType.shortName === 'Taskneed' && this.master.entityAspect.entityState.isAdded()) {
            // Issue: Je kan niet zien of de aanwezigheid goed is aangemaakt #2786
            return false;
        }
        return true;
    };
    /**
     * Deletes a entity.
     * @param item The entity to delete.
     * @param index The location of the entity within the shown list.
     * @returns The deleted entity.
     */
    RelationComponent.prototype.deleteItem = function (item, index) {
        var _this = this;
        if (item === this.current) {
            this.current = null;
        }
        if (item && item.entityType.shortName === 'Taskneed') {
            // Issue: Je kan niet zien of de aanwezigheid goed is aangemaakt #2786
            this.masterEntity['removeNeed'](item['Oid']).subscribe(function (value) {
                _this.breezeService.saveChanges(function (error) {
                    if (error) {
                        _this.alertsService.createAlert('warning', 'APP.LISTS.ITEMS_UNSUCCESSFULLY_DELETED');
                    }
                    else {
                        if (item['Owner_Oid'] === _this.masterEntity['Oid']) {
                            item.entityAspect.setDetached();
                        }
                        _this.dataSet.refresh(); // Reason: inform pagination of a changing dataset #1664
                        _this.alertsService.createAlert('success', 'APP.LISTS.ITEMS_SUCCESSFULLY_DELETED');
                    }
                });
            });
            return item;
        }
        return _super.prototype.deleteItem.call(this, item, index);
    };
    /**
     * Sets domain specific default values.
     * @protected
     * @param {Entity} item The item whose values might be pre-set.
     * @memberOf RelationBase
     */
    RelationComponent.prototype.setDefaultValues = function (item) {
        if (item.entityType.shortName === 'SpendTime') {
            // Fix issue: Bij realiseren periode overnemen die open staat ipv assignment start en eind. #2561
            // We nemen start/end horizon over wanneer deze korter is als default duur spendtime.
            var spendTime = item;
            var state = GridService.fromParamsToState(this.localStorageService, this.translateService.currentLang, {});
            var hStart = state.level.startForDate(state.date);
            var hEnd = state.level.endForDate(state.date);
            var sDuration = moment.duration(moment(spendTime.Finish).diff(moment(spendTime.Start)));
            var hDuration = moment.duration(hEnd.diff(hStart));
            if (hDuration.asMinutes() < sDuration.asMinutes()) {
                spendTime.Start = hStart.toDate();
                spendTime.Finish = hEnd.toDate();
            }
        }
        if ((item.entityType.shortName === 'Service' || item.entityType.shortName === 'ServiceTemplate') &&
            item['Shift'] != null &&
            item['Shift']['Purpose'] === 'FORECAST') {
            item['Purpose'] = 'MINIMUM';
        }
    };
    /**
     * Method to initialize the data set for the first time.
     */
    RelationComponent.prototype.initItemSet = function () {
        var _this = this;
        _super.prototype.initItemSet.call(this);
        if (this.configuration.data) {
            var entityConfig_1 = this.configuration.data;
            switch (entityConfig_1.entity) {
                case 'SpendTime':
                case 'StateMembershipLink':
                case 'StateExpertiseLink':
                case 'StateLocalityLink':
                case 'StateCostLink':
                case 'StateResource':
                    this.subscriptionPool.add(this.breezeService.commitFinishedEvent.subscribe(function (result) {
                        if (result.entities && result.entities.some(function (item) { return item.entityType && item.entityType.shortName === entityConfig_1.entity; })) {
                            _this.refresh();
                        }
                    }));
                    break;
                case 'Taskneed':
                    this.subscriptionPool.add(this.breezeService.commitFinishedEvent.subscribe(function (result) {
                        var found = result.entities ? result.entities.find(function (item) { return (item.entityType && item.entityType.shortName === entityConfig_1.entity) || item['Name'] === 'RemoveNeed'; }) : null;
                        if (found) {
                            if (found['Name'] === 'RemoveNeed' && !found.entityType) {
                                _this.current = null;
                            }
                            _this.refresh();
                        }
                    }));
                    break;
            }
        }
    };
    return RelationComponent;
}(RelationBase));
export { RelationComponent };
